module.exports = __webpack_public_path__ + "static/media/thumb-nail-view.223ee8f0.svg";